import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import AirplaneTicketOutlined from "@mui/icons-material/AirplaneTicketOutlined";
import AlarmOutlined from "@mui/icons-material/AlarmOutlined";
import CurrencyExchangeOutlined from "@mui/icons-material/CurrencyExchangeOutlined";
import EventBusyOutlined from "@mui/icons-material/EventBusyOutlined";
import EventRepeatOutlined from "@mui/icons-material/EventRepeatOutlined";
import FlashOffOutlined from "@mui/icons-material/FlashOffOutlined";
import LanguageOutlined from "@mui/icons-material/LanguageOutlined";
import LuggageOutlined from "@mui/icons-material/LuggageOutlined";
import FlightClassIcon from "@mui/icons-material/FlightClass";
import RouteOutlined from "@mui/icons-material/RouteOutlined";
import SearchOffOutlined from "@mui/icons-material/SearchOffOutlined";
import Signpost from "@mui/icons-material/Signpost";
import WrongLocationOutlined from "@mui/icons-material/WrongLocationOutlined";
import React from "react";

export const ResponseIconMap = {
  PRICE_CHANGE: <CurrencyExchangeOutlined />,
  TIME_CHANGE: <AlarmOutlined />,
  SUITCASE: <LuggageOutlined />,
  FLIGHT_CLASS: <FlightClassIcon />,
  INVALID_DESTINATION: <WrongLocationOutlined />,
  INVALID_DATE: <EventBusyOutlined />,
  INVALID_TICKET: <AirplaneTicketOutlined />,
  INVALID_DATE_ORDER: <EventRepeatOutlined />,
  INVALID_DOMAIN: <LanguageOutlined />,
  SIGN_POST: <Signpost />,
  SEARCH_OFF_OUTLINED: <SearchOffOutlined />,
  FLASH_OFF_OUTLINED: <FlashOffOutlined />,
  ROUTE_OUTLINED: <RouteOutlined />,
  SCHOOL: <SchoolOutlined />,
};
